/* ============================================================
   SerDev – Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileMenu();
  initScrollReveal();
  initFAQ();
  initCookieBanner();
  initHeroCodeAnimation();
});

/* ---- Sticky Header ---- */
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  const onScroll = () => {
    if (window.scrollY > 20) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ---- Mobile Menu ---- */
function initMobileMenu() {
  const btn = document.querySelector('.hamburger');
  const menu = document.querySelector('.mobile-menu');
  if (!btn || !menu) return;

  btn.addEventListener('click', () => {
    btn.classList.toggle('open');
    menu.classList.toggle('open');
    const isOpen = menu.classList.contains('open');
    btn.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      btn.classList.remove('open');
      menu.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

/* ---- Scroll Reveal ---- */
function initScrollReveal() {
  const elements = document.querySelectorAll('.reveal');
  if (!elements.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    elements.forEach(el => el.classList.add('visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  elements.forEach(el => observer.observe(el));
}

/* ---- FAQ Accordion ---- */
function initFAQ() {
  const triggers = document.querySelectorAll('.faq-trigger');
  if (!triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen = content.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-content').forEach(c => c.classList.remove('open'));
      document.querySelectorAll('.faq-trigger').forEach(t => t.classList.remove('active'));

      // Open clicked (if was closed)
      if (!isOpen) {
        content.classList.add('open');
        trigger.classList.add('active');
      }
    });
  });
}

/* ---- Cookie Banner ---- */
function initCookieBanner() {
  const banner = document.querySelector('.cookie-banner');
  if (!banner) return;

  if (document.cookie.includes('serdev_consent=')) return;

  setTimeout(() => {
    banner.classList.add('visible');
  }, 1500);

  const acceptBtn = banner.querySelector('.cookie-accept');
  const declineBtn = banner.querySelector('.cookie-decline');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      document.cookie = 'serdev_consent=true;max-age=31536000;path=/;SameSite=Lax';
      banner.classList.remove('visible');
    });
  }

  if (declineBtn) {
    declineBtn.addEventListener('click', () => {
      document.cookie = 'serdev_consent=false;max-age=31536000;path=/;SameSite=Lax';
      banner.classList.remove('visible');
    });
  }
}

/* ---- Hero Code Background Animation ---- */
function initHeroCodeAnimation() {
  const hero = document.querySelector('.hero');
  if (!hero) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // Replace hero-grid div with canvas container
  const oldGrid = hero.querySelector('.hero-grid');
  if (oldGrid) oldGrid.remove();

  const container = document.createElement('div');
  container.className = 'hero-code-bg';
  const canvas = document.createElement('canvas');
  container.appendChild(container.cloneNode ? canvas : canvas);
  container.innerHTML = '';
  container.appendChild(canvas);
  hero.insertBefore(container, hero.firstChild);

  const ctx = canvas.getContext('2d');

  // SerDev-themed code snippets
  const codeLines = [
    '// SerDev',
    'const project = new SerDev({',
    '  client: "Ihr Unternehmen",',
    '  type: "individual",',
    '  stack: ["Next.js", "Node.js"],',
    '  design: "custom",',
    '  dsgvo: true,',
    '  scalable: true',
    '});',
    '',
    'async function launch(project) {',
    '  await design(project);',
    '  await develop(project);',
    '  await test(project);',
    '  return deploy(project);',
    '}',
    '',
    'class Website extends SerDev {',
    '  constructor(brand) {',
    '    super(brand);',
    '    this.performance = "⚡ 100";',
    '    this.seo = optimized;',
    '  }',
    '}',
    '',
    '// serdev.net – Kein Baukasten.',
    'export default SerDev;',
    '',
    'const stack = {',
    '  frontend: ["React", "Next.js"],',
    '  backend:  ["Node.js", "PHP"],',
    '  db:       ["PostgreSQL", "MySQL"],',
    '  style:    ["Tailwind", "Custom CSS"]',
    '};',
    '',
    'function buildSolution(req) {',
    '  const solution = analyze(req);',
    '  return solution',
    '    .design()',
    '    .develop()',
    '    .optimize()',
    '    .launch();',
    '}',
    '',
    '/** @serdev.net */',
    'import { SerDev } from "@serdev/core";',
    'const app = SerDev.init("serdev.net");',
  ];

  const FONT_SIZE = 13;
  const LINE_HEIGHT = 22;
  const COLS = 3;
  const COLOR_PRIMARY = '#3b82f6';
  const COLOR_GREEN   = '#22c55e';
  const COLOR_PURPLE  = '#a855f7';
  const COLOR_GRAY    = '#94a3b8';
  const COLOR_ORANGE  = '#f97316';

  // Token colorizer
  function tokenize(line) {
    const tokens = [];
    if (line.startsWith('//') || line.startsWith('/**') || line.startsWith(' *')) {
      tokens.push({ text: line, color: COLOR_GREEN });
      return tokens;
    }
    // Simple keyword detection
    const keywords = ['const','let','var','function','class','async','await','return','new','import','export','default','extends','constructor','true','false','super'];
    const words = line.split(/(\s+|[{}()[\]:,."'`])/);
    words.forEach(w => {
      if (keywords.includes(w.trim())) tokens.push({ text: w, color: COLOR_PRIMARY });
      else if (/^["'`]/.test(w.trim()) || /["'`]$/.test(w.trim())) tokens.push({ text: w, color: COLOR_ORANGE });
      else if (/^\d+$/.test(w.trim())) tokens.push({ text: w, color: COLOR_PURPLE });
      else tokens.push({ text: w, color: COLOR_GRAY });
    });
    return tokens;
  }

  // Column state
  let columns = [];

  function resize() {
    canvas.width  = hero.offsetWidth;
    canvas.height = hero.offsetHeight;
    initColumns();
  }

  function initColumns() {
    columns = [];
    const colWidth = canvas.width / COLS;
    for (let c = 0; c < COLS; c++) {
      const startLine = Math.floor(Math.random() * codeLines.length);
      columns.push({
        x: c * colWidth + 24,
        y: -Math.random() * canvas.height,
        lineIndex: startLine,
        charIndex: 0,
        lines: [],        // rendered lines
        speed: 0.4 + Math.random() * 0.3,
      });
    }
  }

  let lastTime = 0;
  let charAccum = 0;

  function draw(timestamp) {
    const delta = timestamp - lastTime;
    lastTime = timestamp;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = `${FONT_SIZE}px "Satoshi", "General Sans", monospace`;

    const charsPerFrame = delta * 0.18; // typing speed
    charAccum += charsPerFrame;
    const newChars = Math.floor(charAccum);
    charAccum -= newChars;

    columns.forEach(col => {
      // Scroll upward
      col.y -= col.speed;

      // Add new characters / lines
      for (let i = 0; i < newChars; i++) {
        const currentSrc = codeLines[col.lineIndex % codeLines.length];
        if (col.charIndex === 0) {
          col.lines.push({ tokens: [], srcLen: currentSrc.length });
        }
        const currentLine = col.lines[col.lines.length - 1];
        if (col.charIndex < currentSrc.length) {
          // rebuild tokens up to charIndex for live-type effect
          currentLine.tokens = tokenize(currentSrc.slice(0, col.charIndex + 1));
          col.charIndex++;
        } else {
          col.charIndex = 0;
          col.lineIndex++;
        }
      }

      // Cull lines that scrolled off top
      while (col.lines.length > 60) col.lines.shift();

      // Draw lines
      col.lines.forEach((line, i) => {
        const lineY = col.y + i * LINE_HEIGHT;
        if (lineY < -LINE_HEIGHT || lineY > canvas.height + LINE_HEIGHT) return;

        // Fade based on position
        const fadeTop    = Math.min(1, (lineY) / 80);
        const fadeBottom = Math.min(1, (canvas.height - lineY) / 80);
        const fade = Math.min(fadeTop, fadeBottom);
        if (fade <= 0) return;

        let drawX = col.x;
        line.tokens.forEach(tok => {
          ctx.globalAlpha = fade;
          ctx.fillStyle = tok.color;
          ctx.fillText(tok.text, drawX, lineY);
          drawX += ctx.measureText(tok.text).width;
        });
      });

      ctx.globalAlpha = 1;

      // Reset column when fully off top
      if (col.y + col.lines.length * LINE_HEIGHT < -50) {
        col.y = canvas.height + 20;
        col.lines = [];
        col.charIndex = 0;
        col.lineIndex = Math.floor(Math.random() * codeLines.length);
        col.speed = 0.4 + Math.random() * 0.3;
      }
    });

    requestAnimationFrame(draw);
  }

  resize();
  window.addEventListener('resize', resize, { passive: true });
  requestAnimationFrame(draw);
}